<template>
  <div class="indicator-title-wrapper">

    <h1 class="title">
      {{ titleArray[0] }}
<!--      <animated-number v-if="dataLast !== null" class="counter-inline"-->
<!--                       :value="dataLast"-->
<!--                       :duration="duration"-->
<!--                       :formatValue="formatAnimatedNumber"-->
<!--                       easing="easeOutQuart" />-->
      {{ dataLastFormattedString }}{{ titleArray[1] }}
    </h1>

    <div class="counter" v-if="dataLast" role="presentation">
      <div class="counter-inner">
        <animated-number v-if="dataLast !== null"
                         :value="dataLast"
                         :duration="duration"
                         :formatValue="formatAnimatedNumber"
                         easing="easeOutQuart" />
        <span :class="dataSuffixClasses">{{ dataSuffix }}</span>
      </div>
    </div>

  </div>
</template>

<script>
  import AnimatedNumber from "animated-number-vue"

  export default {
    name: 'IndicatorTitle',
    components: {
      AnimatedNumber
    },
    props: {
      page: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        duration: 1000
      };
    },
    methods: {
      formatAnimatedNumber(value) {
        // Formatted to be the same amount of digits as the final number. E.g:
        // A value of 654 needs to start as 000.
        // This should stop the title text re-flowing and janking about.
        let roundedNum = Number(value).toFixed(0)
        const finalLength = Number(this.dataLast).toFixed(0).length
        const currentLength = roundedNum.length
        if (currentLength < finalLength) {
          roundedNum = roundedNum.padStart(finalLength, 0)
        }
        return String(this.formatThousands(roundedNum))
      },
      formatThousands(num) {
        // Formats an incoming number with a comma thousands separator.
        // Returns a string.
        if (num >=1000) {
          // Credit: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript/2901298#2901298
          let parts = num.toString().split(".");
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          num = parts.join(".");
        }
        return String(num)
      },
    },
    computed: {
      dataLast() {
        if (this.page.data) {
          // Last value in data.datasets[0].data array
          return this.page.data.datasets[0].data.slice(-1)[0]
        } else {
          return null
        }
      },
      dataLastFormattedString() {
        if (this.dataLast === null) {
          return ""
        }
        return String(this.formatThousands(this.dataLast))
      },
      dataSuffix() {
        if (this.page.dataSuffix) {
          return this.page.dataSuffix
        } else {
          return ""
        }
      },
      dataSuffixClasses() {
        if (this.page.dataSuffix) {
          let classes = ["data-suffix"]
          if (this.page.dataSuffix === "%") {
            classes.push("data-suffix-inline")
          } else {
            classes.push("data-suffix-block")
          }
          return classes
        } else {
          return ""
        }
      },
      title() {
        let title = this.page.title
        if (this.page.data) {
          // Last value in labels array (could be a global default or set by the page)
          let labelLast = ''
          if (this.page.data.labels === "default") {
            labelLast = this.$store.state.globalData.defaults.data.defaultLabels.labels.slice(-1)[0]
          } else {
            labelLast = this.page.data.labels.slice(-1)[0]
          }
          // Replace tokens
          // Data token
          // title = title.replace("{{data-last}}", String(this.dataLast))
          // Label token
          title = title.replace("{{label-last}}", String(labelLast))
        }
        return title
      },
      titleArray() {
        // Split the title into an array of strings, not including the data token.
        return this.title.split('{{data-last}}')
      },
    }
  }
</script>

<style src="./IndicatorTitle.scss" lang="scss"></style>
